import React, { type ComponentType } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { ReactGadgetProps } from '@atlassian/jira-react-gadgets-common/src/types.tsx';
import { FilterResultsEditSkeleton } from '@atlassian/jira-skeletons/src/ui/dashboard/components/filter-results-edit.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { IssueTableGadgetEditData } from '../../../types.tsx';

const LazyIssuesInProgressGadgetEdit = lazyForPaint<
	ComponentType<ReactGadgetProps<IssueTableGadgetEditData>>
>(() => import(/* webpackChunkName: "async-react-issues-in-progress-gadget-edit" */ './main'));

export const IssuesInProgressGadgetEdit = (props: ReactGadgetProps<IssueTableGadgetEditData>) => (
	<Placeholder name="issues-in-progress-gadget-edit" fallback={<FilterResultsEditSkeleton />}>
		<LazyIssuesInProgressGadgetEdit {...props} />
	</Placeholder>
);

export const { preload } = LazyIssuesInProgressGadgetEdit;
